export default __webpack_public_path__ + "static/form-multiple-action-buttons-dont-461accd9be8c694e4f67114fd684fef7.png";